import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    number: '01',
    title: 'BONO 1 — Pack Fichas Listas para Imprimir',
    description: 'Sesión documentada en 2 minutos. Lista para la historia clínica.',
    value: '$4.90'
  }, {
    number: '02',
    title: 'BONO 2 — Scriptbook: Qué Decir / Qué No Decir',
    description: '+80 frases exactas para motivar, corregir y guiar sin frustrar al paciente',
    value: '$5.90'
  }, {
    number: '03',
    title: 'BONO 3 — Tracker Semáforo de Progresión',
    description: 'Dashboard visual verde/amarillo/rojo para mostrarle al paciente su avance real',
    value: '$5.40'
  }];
  return <section className="w-full bg-[#0a1410] py-8 md:py-16" data-id="element-34">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-36">
          {/* Header */}
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-6 md:mb-12" data-id="element-37">
            🎁 3 BONOS ESTRATÉGICOS — SIEMPRE INCLUIDOS
          </h2>

          {/* Bonuses Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-6 md:mb-10" data-id="element-38">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-[#0f1f17] border border-amber-900/30 rounded-lg p-6" data-id="element-39">
                <div className="flex items-start gap-3 mb-4" data-id="element-40">
                  <Gift className="w-6 h-6 text-amber-500 flex-shrink-0" data-id="element-41" />
                  <span className="text-sm font-bold text-amber-500" data-id="element-42">
                    #{bonus.number}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-white mb-3" data-id="element-43">
                  {bonus.title}
                </h3>
                <p className="text-gray-300 text-sm mb-4 leading-relaxed" data-id="element-44">
                  {bonus.description}
                </p>
                <div className="flex items-center gap-2" data-id="element-45">
                  <span className="text-gray-500 line-through" data-id="element-46">
                    {bonus.value}
                  </span>
                  <span className="text-amber-500 font-bold" data-id="element-47">GRATIS</span>
                </div>
              </motion.div>)}
          </div>

          {/* Total Value */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-center" data-id="element-48">
            <p className="text-xl md:text-2xl font-bold text-white" data-id="element-49">
              Valor total bonos:{' '}
              <span className="line-through text-gray-500" data-id="element-50">$16.20 usd</span>
              {' → '}
              <span className="text-amber-500" data-id="element-51">GRATIS con tu Atlas</span>
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}